module.exports = __webpack_public_path__ + "static/media/template3-carousel.737f1357.png";